import { Component, Output, EventEmitter, input, inject } from '@angular/core';
import { Validators, ReactiveFormsModule, NonNullableFormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BasicAuthCredentials } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-app-credentials-un-pw-form',
    imports: [MatFormFieldModule, ReactiveFormsModule, MatSelectModule, MatButtonModule, MatInputModule],
    template: `
        <form [formGroup]="loginFormGroup">
            <h1 id="sign-in-header">Sign In</h1>
            @if (loginError()) {
                <mat-error id="auth-error">
                    {{ loginError() }}
                </mat-error>
            }
            <mat-form-field appearance="outline" id="username">
                <mat-label>Username</mat-label>
                <input matInput formControlName="username" name="username" autocomplete="username" />
                @if (loginFormGroup.controls['username'].errors?.['required']) {
                    <mat-error>Username required</mat-error>
                }
                @if (loginFormGroup.controls['username'].errors?.['username']) {
                    <mat-error>Invalid username</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="outline" id="password">
                <mat-label>Password</mat-label>
                <input
                    matInput
                    formControlName="password"
                    type="password"
                    name="password"
                    autocomplete="current-password" />
                @if (loginFormGroup.controls['password'].errors?.['required']) {
                    <mat-error>Password required</mat-error>
                }
            </mat-form-field>
            <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="loginFormGroup.invalid"
                (click)="onSubmitLoginForm()">
                Sign In
            </button>
        </form>
    `,
    styleUrl: './credentials-un-pw-form.component.scss',
})
export class CredentialsUnPwFormComponent {
    readonly #formBuilder = inject(NonNullableFormBuilder);

    loginError = input<string | undefined>();

    @Output()
    submitLoginForm = new EventEmitter<BasicAuthCredentials>();

    loginFormGroup = this.#formBuilder.group({
        username: this.#formBuilder.control('', [Validators.required]),
        password: this.#formBuilder.control('', [Validators.required]),
    });

    onSubmitLoginForm() {
        const rawLoginInfo = this.loginFormGroup.getRawValue();
        rawLoginInfo.username = rawLoginInfo.username.toLowerCase();
        this.submitLoginForm.emit(rawLoginInfo);
    }
}
